export const VOICE_COACH_ON_DEVICE_TTS_STORAGE_KEY = 'forza.voiceCoach.onDeviceTts.v1';

function getStorage(storage) {
  if (storage) {
    return storage;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readOnDeviceTtsPreference(storage) {
  const target = getStorage(storage);
  if (!target) {
    return false;
  }
  try {
    return target.getItem(VOICE_COACH_ON_DEVICE_TTS_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeOnDeviceTtsPreference(enabled, storage) {
  const target = getStorage(storage);
  if (!target) {
    return false;
  }
  try {
    if (enabled) {
      target.setItem(VOICE_COACH_ON_DEVICE_TTS_STORAGE_KEY, 'true');
    } else {
      target.removeItem(VOICE_COACH_ON_DEVICE_TTS_STORAGE_KEY);
    }
    return true;
  } catch {
    return false;
  }
}

export function hasKokoroAssetsInstalled(caps, kokoroReady = false) {
  if (kokoroReady) {
    return true;
  }
  return Boolean(
    caps?.kokoroAssetsInstalled
    || (caps?.kokoroModelExists && caps?.kokoroVoicesExists)
  );
}

export function shouldPromptForVoiceMode({
  isNativeApp,
  kokoroAvailable,
  caps,
  kokoroReady = false,
}) {
  if (!isNativeApp) {
    return false;
  }
  if (kokoroAvailable === false) {
    return false;
  }
  return !hasKokoroAssetsInstalled(caps, kokoroReady);
}

export function shouldProactivelyInitKokoro({
  isNativeApp,
  kokoroAvailable,
  caps,
  kokoroReady = false,
  requestedMode = null,
  onDevicePreferenceEnabled = false,
}) {
  if (!hasKokoroAssetsInstalled(caps, kokoroReady)) {
    return false;
  }
  return resolveVoiceCoachTtsMode({
    requestedMode,
    isNativeApp,
    kokoroAvailable,
    onDevicePreferenceEnabled,
  }) === 'native_text';
}

export function shouldGateFirstTimeLocalSetup({
  isNativeApp,
  selectedMode,
  assetsInstalledAtSelection = false,
}) {
  return Boolean(
    isNativeApp
    && selectedMode === 'native_text'
    && !assetsInstalledAtSelection
  );
}

export function isFirstTimeLocalSetupReady({
  firstTimeLocalSetupActive = false,
  kokoroReady = false,
  kokoroWarm = false,
}) {
  return Boolean(firstTimeLocalSetupActive && kokoroReady && kokoroWarm);
}

export function resolveVoiceCoachTtsMode({
  requestedMode = null,
  isNativeApp,
  kokoroAvailable,
  onDevicePreferenceEnabled = false,
}) {
  const nativeSupported = Boolean(isNativeApp && kokoroAvailable !== false);

  if (requestedMode === 'server_pcm') {
    return 'server_pcm';
  }
  if (requestedMode === 'native_text') {
    return nativeSupported ? 'native_text' : 'server_pcm';
  }
  if (onDevicePreferenceEnabled && nativeSupported) {
    return 'native_text';
  }
  return nativeSupported ? 'native_text' : 'server_pcm';
}
